import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useRouter } from "next/router";

import BreadcrumbsHeader from "./BreadcrumbsHeader";
import BreadCrumbs from "@/shared/components/Breadcrumbs/BreadCrumbs";

import useMediaQuery, { MEDIA_QUERIES } from "@/shared/hooks/useMediaQuery";
import { URLS } from "@/shared/utils/url/url";
import { makeChapterUrl } from "@/utils/routes/routes";
import { useCustomHistory } from "@/contexts/history";
import { NEXT_URLS } from "@/utils/routes/routes.constants";
import { getBookIdWithPrefix } from "@/shared/utils/content/content";
import { BreadcrumbType } from "@/shared/utils/breadcrumbs/constants";

import styles from "./breadcrumbs.module.scss";

const createBcUrl = (item) => {
  if (item) {
    const { id, type, url } = item;
    if (url) {
      return url;
    }
    if (type === BreadcrumbType.folder) {
      return NEXT_URLS.allCollection + "/" + item.id;
    }
    if (type === BreadcrumbType.book) {
      return NEXT_URLS.bookInfo + "/" + getBookIdWithPrefix(id);
    }
    if (type === BreadcrumbType.chapter) {
      return makeChapterUrl(id);
    }
    if (type === BreadcrumbType.lang) {
      return NEXT_URLS.allCollection + "/" + item.lang;
    }
  }
  return URLS.home;
};

const Breadcrumbs = ({ title, breadcrumbs, folderType, isLanding, ...props }) => {
  const router = useRouter();

  const history = useCustomHistory();
  const canHover = useMediaQuery(MEDIA_QUERIES.canHover);

  const handleCrumbClick = (item, index) => {
    if (item.type !== BreadcrumbType.nonClickable) {
      const itemUrl = createBcUrl(item);

      const isMainCrumb = index === 0;

      if ((canHover && !isLanding) || isMainCrumb) {
        router.push(itemUrl, undefined, {
          shallow: item.type !== BreadcrumbType.folder,
        });
      } else {
        if (item.type === BreadcrumbType.externalUrl) {
          window.open(itemUrl, "_self");
        } else {
          router.push(itemUrl);
        }
      }
    }
  };

  const handleBackClick = () => {
    if (isLanding) {
      router.push("/");
      return;
    }
    history.back("/");
  };

  return (
    <div className={classNames(styles["breadcrumbs"], "breadcrumbs")} {...props}>
      <BreadcrumbsHeader folderType={folderType} title={title} onClickBack={handleBackClick} />
      {breadcrumbs && (
        <BreadCrumbs
          folderType={folderType}
          items={breadcrumbs}
          onClickItem={handleCrumbClick}
        />
      )}
    </div>
  );
};

Breadcrumbs.defaultProps = {
  title: "",
  breadcrumbs: [],
};

Breadcrumbs.propTypes = {
  title: PropTypes.string,
  breadcrumbs: PropTypes.array,
  realType: PropTypes.string,
  isLanding: PropTypes.bool,
};

export default Breadcrumbs;
